module.exports = __webpack_public_path__ + "static/media/appicon.3aa0f7ee.png";